import { useLocation } from 'react-router-dom';

/**
 * Custom hook that returns the current pathname from the router location.
 * @returns The current pathname without a trailing slash.
 */

export function usePathname(): string {
  const location = useLocation();

  return location.pathname.endsWith('/')
    ? location.pathname.slice(0, -1)
    : location.pathname;
}
